// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-event-create .sidebar {
  width: 300px;
}
.admin-event-create .content-wrapper {
  height: calc(100vh - 160px);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/routes/admin-panel/event-create/style.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;AAGE;EACE,2BAAA;EACA,cAAA;AADJ","sourcesContent":[".admin-event-create {\n  .sidebar {\n    width: 300px;\n  }\n\n  .content-wrapper {\n    height: calc(100vh - 160px);\n    overflow: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
